import { useState, useEffect, useRef } from "react";
import { Check } from "lucide-react";

const RHYTHMS = {
  normal: { label: "Normal", phases: [{ label: "Inspirez…", ms: 4000, scale: 1 }, { label: "Retenez…", ms: 2000, scale: 1 }, { label: "Expirez…", ms: 5000, scale: 0.55 }] },
  lent: { label: "Lent", phases: [{ label: "Inspirez…", ms: 5500, scale: 1 }, { label: "Retenez…", ms: 3000, scale: 1 }, { label: "Expirez…", ms: 7000, scale: 0.55 }] },
  tres_lent: { label: "Très lent", phases: [{ label: "Inspirez…", ms: 7000, scale: 1 }, { label: "Retenez…", ms: 4000, scale: 1 }, { label: "Expirez…", ms: 9000, scale: 0.55 }] },
};

export default function BreathingPlayer({ onComplete }) {
  const [rhythm, setRhythm] = useState("normal");
  const [phase, setPhase] = useState(0);
  const [cycles, setCycles] = useState(0);
  const start = useRef(Date.now());

  const PHASES = RHYTHMS[rhythm].phases;

  useEffect(() => {
    const t = setTimeout(() => {
      const nextP = (phase + 1) % PHASES.length;
      setPhase(nextP);
      if (nextP === 0) setCycles((c) => c + 1);
    }, PHASES[phase].ms);
    return () => clearTimeout(t);
  }, [phase, rhythm]);

  const p = PHASES[phase];

  return (
    <div className="w-full max-w-xl mx-auto text-center" data-testid="breathing-player">
      <div className="flex justify-center gap-2 mb-6" data-testid="breathing-rhythm">
        {Object.entries(RHYTHMS).map(([k, v]) => (
          <button key={k} onClick={() => { setRhythm(k); setPhase(0); }} data-testid={`breathing-rhythm-${k}`}
            className={`px-5 h-11 rounded-full font-patient font-bold text-lg transition-colors ${rhythm === k ? "bg-emerald-700 text-white" : "bg-white border-2 border-emerald-200 text-emerald-700"}`}>
            {v.label}
          </button>
        ))}
      </div>
      <div className="flex items-center justify-center h-72 mb-6">
        <div className="rounded-full flex items-center justify-center"
          style={{
            width: 220, height: 220,
            transform: `scale(${p.scale})`,
            transition: `transform ${p.ms}ms ease-in-out`,
            background: "radial-gradient(circle at 50% 40%, #7fe3d8 0%, #2E8EC2 70%)",
          }}>
          <span className="font-patient font-black text-white text-3xl">{p.label}</span>
        </div>
      </div>
      <p className="font-patient text-xl text-gray-500 mb-2">Respirez doucement en suivant le cercle.</p>
      <p className="font-care text-emerald-700 font-bold mb-6">Cycles complétés : {cycles}</p>
      <button onClick={() => onComplete({ score: 100, accuracy: 100, duration: Math.round((Date.now() - start.current) / 1000) })}
        data-testid="breathing-done"
        className="w-full h-16 rounded-2xl bg-amber-400 text-amber-950 font-patient font-black text-2xl inline-flex items-center justify-center gap-3 active:scale-[0.98] transition-transform">
        Terminé <Check className="w-7 h-7" />
      </button>
    </div>
  );
}

